import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeyValueDTO } from '@ms/core';
import { logRequest } from 'app/main/shared/http-utils';
import { Observable } from 'rxjs';
import { ISalaryPlan, SalaryPlan, SalaryPlanSearch } from '../salary-plans/salary-plan.model';
import { PlanDetail } from './../salary-plans/salary-plan.model';

@Injectable({
    providedIn: 'root',
})
export class SalaryPlanService {
    baseUrl = '/school-service/api/salary-plans';

    constructor(private http: HttpClient) {}

    getById(id: string): Observable<HttpResponse<ISalaryPlan>> {
        return this.http.get<ISalaryPlan>(this.baseUrl + id, {
            observe: 'response',
        });
    }

    save(budgetSalary: SalaryPlan): Observable<HttpResponse<ISalaryPlan>> {
        return this.http.post<SalaryPlan>(this.baseUrl, budgetSalary, { observe: 'response', headers: logRequest() });
    }

    update(budgetSalary: SalaryPlan): Observable<HttpResponse<ISalaryPlan>> {
        return this.http.put<SalaryPlan>(this.baseUrl, budgetSalary, { observe: 'response', headers: logRequest() });
    }

    delete(id: any): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${id}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    search(searchDTO: SalaryPlanSearch): Observable<HttpResponse<ISalaryPlan[]>> {
        return this.http.post<ISalaryPlan[]>(`${this.baseUrl}/search`, searchDTO, { observe: 'response' });
    }

    checkPlanDetail(detail: PlanDetail): Observable<HttpResponse<any>> {
        return this.http.post<any[]>(`${this.baseUrl}/check-detail`, detail, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    getSalaryPlanKeyValueDTO(budgetId: string): Observable<KeyValueDTO[]> {
        return this.http.get<KeyValueDTO[]>(`${this.baseUrl}/select/budget${budgetId}`);
    }
}
